import { Inject, Injectable, computed, effect, inject } from '@angular/core';
import { BehaviorSubject, Observable, throwError } from 'rxjs';
import { catchError, retry, switchMap, tap } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Ability, AbilityBuilder } from '@casl/ability';
import { KeycloakService } from 'keycloak-angular';
import { JwtService } from './jwt.service';
import { SignalStore } from 'src/app/shared/functions/store.functions';
import { createEffect } from 'src/app/shared/functions/create-effect.functions';
import { AuthState } from '../models/auth.model';
import { AUTH_CONFIG } from 'src/app/config/auth.config';
import { environment } from 'src/environments/environment';
import { Rules } from '../models/authorization-rules.model';
import { ApiService } from './api.service';
import { toSignal } from '@angular/core/rxjs-interop';
import { UtentiService } from 'src/app/modules/amministrazione/utenti.service';
import { RoleState } from '../models/role.model';
import { LocalStorageService } from './local-storage.service';

const AUTH_ENDPOINT = environment.apiSentrynelUrl;
const LOGIN_URL = `${AUTH_ENDPOINT}/login`;
const PROFILE_URL = `${AUTH_ENDPOINT}/auth/user`;
const LOGOUT_URL = `${AUTH_ENDPOINT}/logout`;
@Injectable({
  providedIn: 'root'
})
export class AuthService {
  private defineAbilitySubject: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  // Aggiungi un flag observable che indica se l'abilità è stata definita
  public abilityDefined$: Observable<boolean> = this.defineAbilitySubject.asObservable();

  readonly user = this.authStore.select(store => store.user);
  public isAuthenticated = computed(() => this.jwtService.isValidToken());
  public isSetUser = toSignal(this.abilityDefined$, { initialValue: false });


  constructor(
    public readonly utentiService: UtentiService,
    private jwtService: JwtService,
    private keycloakService:KeycloakService,
    private apiService: ApiService,
    private ability: Ability,
    private https:HttpClient,
    private localStorageService:LocalStorageService,
    @Inject('auth-store') private readonly authStore = inject(SignalStore<AuthState>),
    @Inject('role-store') private readonly roleStore = inject(SignalStore<RoleState>)
  ) {
    effect(() => {
      if (AUTH_CONFIG.fetchUserAfterLogin && this.isAuthenticated()) {
        this.fetchUser();
      }
    });
  }

  private defineAbility(rolePerm: any): void {

    const { can, rules } = new AbilityBuilder(Ability);

    const regole: Rules[] = Array.isArray(rolePerm) ? rolePerm.shift().permissions : rolePerm.permissions;
    regole.forEach(regola => {
      can(regola?.action, regola.subject!);
    });
    this.ability.update(rules);

    this.defineAbilitySubject.next(true);
  }

  public async fetchUser(): Promise<void> {
    return new Promise((resolve, reject) => {
      this.https.get<any>(PROFILE_URL).pipe(
        retry(1),
        catchError(error => {
          this.handleError(error);
          reject(error);
          return throwError(error);
        }),
        tap((user) => {
          this.authStore.setKey('user', user);
          var roll=user.authorization.roles.join(",")
          this.utentiService.getRoles(roll).subscribe((val:any)=>
            {
         
              if(val.data.length>0){
                this.roleStore.setKey('role', val.data)
                if(this.localStorageService.getItem('role')!=null && this.isStringNumber(this.localStorageService.getItem('role'))){
                  this.apiService.setHeader('RuoloAntea', this.localStorageService.getItem('role')!)
                  this.defineAbility(this.roleStore.selectKey('role')().filter((el:any)=>{

                    return el.id==parseInt(this.localStorageService.getItem('role')!)

                  }));
                }else{
                  this.apiService.setHeader('RuoloAntea', this.roleStore.selectKey('role')()[0].id)
                  this.localStorageService.setItem('role', this.roleStore.selectKey('role')()[0].id)
                  this.defineAbility(this.roleStore.selectKey('role')()[0]);
                }
               
              }

            })

        
          resolve(); // Risolvi la promessa dopo aver definito l'abilità
        })
      ).subscribe();
    });
  }

  public logout() {
    this.jwtService.unset()
    this.localStorageService.clear()
    this.keycloakService.logout(environment.keycloak.redirectUrl)
   // this.router.navigate(['login'], {onSameUrlNavigation: 'reload'});
  }

  handleError(error: any): any {
    throw new Error('Method not implemented.');
  }

  isStringNumber(value:any):boolean {
    // 1. Controlla che il valore non sia undefined o null
    if (value === undefined || value === null) {
      return false;
    }
  
    // 2. Controlla che sia una stringa e che non sia '[object Object]'
    if (typeof value !== 'string' || value === '[object Object]') {
      return false;
    }
  
    // 3. Controlla che la stringa rappresenti un numero valido
    return !isNaN(value as any) && value.trim() !== '';
  }
}
